/*
 * Load More button for collection pages.
 * Replaces standard pagination on storefront. Uses Section Rendering API to fetch
 * the next page and append its product cards to #product-grid.
 *
 * Markup expected (rendered by sections/main-collection-product-grid.liquid):
 *   <button id="LoadMoreButton" data-next-url="..." data-section-id="..." ...>
 *   <div class="pagination-fallback" hidden>  (only shown when JS fails)
 *
 * If filters/sorting re-render the section, facets.js replaces #ProductGridContainer
 * and our button instance is freshly bound on the new DOM via the event delegation below.
 */
(function () {
  function init() {
    bindButton(document.getElementById('LoadMoreButton'));
  }

  function bindButton(btn) {
    if (!btn || btn.dataset.bound === '1') return;
    btn.dataset.bound = '1';
    btn.addEventListener('click', onClick);
  }

  async function onClick(e) {
    const btn = e.currentTarget;
    const nextUrl = btn.dataset.nextUrl;
    const sectionId = btn.dataset.sectionId;
    if (!nextUrl || !sectionId) return;

    const loadingText = btn.dataset.loadingText || 'Loading…';
    const defaultText = btn.dataset.defaultText || btn.textContent.trim();
    btn.disabled = true;
    btn.textContent = loadingText;

    try {
      const url = nextUrl + (nextUrl.includes('?') ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
      const res = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const currentGrid = document.getElementById('product-grid');
      const newItems = doc.querySelectorAll('#product-grid > li');
      if (currentGrid && newItems.length) {
        newItems.forEach((li) => currentGrid.appendChild(li.cloneNode(true)));
      }

      // Update or hide button based on whether the fetched page itself has a next link.
      const newBtn = doc.getElementById('LoadMoreButton');
      if (newBtn && newBtn.dataset.nextUrl) {
        btn.dataset.nextUrl = newBtn.dataset.nextUrl;
        btn.disabled = false;
        btn.textContent = defaultText;
      } else {
        btn.parentElement && btn.parentElement.style && (btn.parentElement.style.display = 'none');
      }
    } catch (err) {
      console.error('[load-more] fetch failed:', err);
      btn.disabled = false;
      btn.textContent = defaultText;
      // Reveal fallback pagination so the user can still navigate.
      var fallback = document.querySelector('.pagination-fallback');
      if (fallback) fallback.hidden = false;
    }
  }

  // Re-bind after facets.js (or anything else) swaps the grid container.
  function observeRebind() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    var observer = new MutationObserver(function () {
      bindButton(document.getElementById('LoadMoreButton'));
    });
    observer.observe(container, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); observeRebind(); });
  } else {
    init();
    observeRebind();
  }
})();
